module.exports = __webpack_public_path__ + "img/weather-icon.7f7bdb8f.svg";